import { IProductCompensation, IProductProps } from '../Entities';

export function notInList(productCompensations: IProductCompensation[], product: IProductProps) {
    if (!productCompensations) {
        return true;
    }
    return (
        productCompensations.filter(
            (pp: IProductCompensation) => pp.productId.toString() === product.id.toString()
        ).length === 0
    );
}
